<template>
   <PageHeader></PageHeader>
  <div class="portfolio">
    <h3>Portfolio</h3>
    
    <div class="photo-grid">
      <div
        class="photo-item"
        v-for="(photo, index) in photos"
        :key="index"
      >
        <img
          :src="photo"
          alt="Portfolio photo"
          @click="openLightbox(index)"
          />

      </div>
    </div>

    <!-- Lightbox Overlay -->
    <div
      v-if="showLightbox"
      class="lightbox-overlay"
      @click.self="closeLightbox"
    >
      <button class="lightbox-close" @click="closeLightbox">&times;</button>
      <button class="lightbox-prev" @click="prevPhoto">&#10094;</button>
      <div class="lightbox-content">
      <img
        :src="photos[currentIndex]"
        class="lightbox-image"
        alt="Large view"
	/>
      <div class="lightbox-caption">{{ captions[currentIndex] }}
      </div>
</div>

      <button class="lightbox-next" @click="nextPhoto">&#10095;</button>
    </div>
  </div>
</template>

<script>
import PageHeader from './PageHeader.vue';


export default {
name: 'Portfolio',
components: {
    PageHeader
  },
  data() {
  return {
          showLightbox: false,
      currentIndex: 0,
      photos: [
	  "/portfolio/1.jpg",
	  "/portfolio/2.jpg",
	  "/portfolio/3.jpg",
	  "/portfolio/4.jpg",
	  "/portfolio/5.jpg",
	  "/portfolio/9.jpg",
	  "/portfolio/10.jpg",
	  "/portfolio/13.jpg",
	  "/portfolio/14.jpg",
	  "/portfolio/15.jpg",
	  "/portfolio/16.jpg",
	  "/portfolio/17.jpg",
	  "/portfolio/18.jpg",
	  "/portfolio/19.jpg",
	  "/portfolio/20.jpg",
	  "/portfolio/21.jpg",
	  "/portfolio/22.jpg",
	  "/portfolio/23.jpg",	  	  
	  "/portfolio/24.jpg",
	  "/portfolio/25.jpg",
	  "/portfolio/26.jpg",
	  "/portfolio/27.jpg",
	  "/portfolio/28.jpg",
	  "/portfolio/29.jpg",
	  "/portfolio/30.jpg",
	  "/portfolio/31.jpg",
	  "/portfolio/32.jpg",
	  "/portfolio/33.jpg",
	  "/portfolio/34.jpg",
	  "/portfolio/35.jpg",
	  "/portfolio/36.jpg",
	  "/portfolio/37.jpg",
	  "/portfolio/38.jpg",
	  "/portfolio/39.jpg",
	  "/portfolio/40.jpg",
	  "/portfolio/41.jpg",
	  "/portfolio/42.jpg",
	  "/portfolio/43.jpg",
	  "/portfolio/44.jpg",
	  "/portfolio/45.jpg",
	  "/portfolio/46.jpg",
	  "/portfolio/47.jpg",
	  "/portfolio/48.jpg",		  
	  "/portfolio/49.jpg",
	  "/portfolio/50.jpg",
	  "/portfolio/51.jpg",
	  "/portfolio/52.jpg",		  
	  	  "/portfolio/53.jpg",		  
	  
      ],
      captions: [
        // TODO: replace these with your actual captions
        'Howth, Ireland',
        'Howth, Ireland',
        'Howth, Ireland',
        'Howth, Ireland',
        'Howth, Ireland',
        'Howth, Ireland',
       'Dublin, Ireland',

	     'DC, US',
          'DC, US',
	  'DC, US',
	  'DC, US',
	  'DC, US',
'Amsterdam',
'Amsterdam',
'Amsterdam',
'Amsterdam',
	  'Amsterdam',
'Amsterdam',
'Amsterdam',
	  'Amsterdam',
	  'Amsterdam',
'Amsterdam',
'Amsterdam',
	  'Amsterdam',
	  'Amsterdam',
'Amsterdam',
'Amsterdam',
	  'Amsterdam',
	  'Amsterdam',
'Amsterdam',


	  'Leipzig, Germany',
	  'Leipzig, Germany',
	  'Leipzig, Germany',
	  'Leipzig, Germany',
  "Berlin",
	  "Berlin",
	  "Berlin",
	  "Berlin",
	  "Berlin",
	  "Berlin",
	  "Berlin",
	  "Berlin",
	  "Berlin",		  
	  "Berlin",
	  "Berlin",
	  "Berlin",
	  "Berlin",		  
	  	  "Berlin",		 	  

      ],
    };
  },
  methods: {

    openLightbox(index) {
      this.currentIndex = index;
      this.showLightbox = true;
    },
    closeLightbox() {
      this.showLightbox = false;
    },
    prevPhoto() {
      this.currentIndex =
        (this.currentIndex + this.photos.length - 1) % this.photos.length;
    },
    nextPhoto() {
      this.currentIndex =
        (this.currentIndex + 1) % this.photos.length;
    },
}
};
</script>

<style scoped>

.portfolio h3 {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;    /* lighter still */
  font-size: 1.5rem;   /* 24px */
  line-height: 1.4;
  margin: 1rem 0;
  text-align: center;    /* often nice for titles */
  color: orange;
}

.portfolio h2 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  text-align: center;    /* often nice for titles */
}
  .portfolio h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  text-align: center;    /* often nice for titles */
}

.portfolio {
  padding: 16px;
}

.photo-grid {
    display: grid;
    /*
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
   */
     grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}


.photo-item img {
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.2s;
}



  /*
  .photo-item {

  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 8px;
  }
  */
.photo-item img:hover {
  transform: scale(1.05);
}

.caption {
  padding: 8px;
  text-align: center;
  font-size: 0.9rem;
  color: #555;
  background: #fff;
}

/* Lightbox Styles */
.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.lightbox-content {
  max-width: 90%;
  max-height: 80%;
  text-align: center;
}

.lightbox-image {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 4px;
}

.lightbox-caption {
  margin-top: 12px;
  color: #fff;
  font-size: 1rem;
}

.lightbox-close,
.lightbox-prev,
.lightbox-next {
  position: absolute;
  background: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
}

.lightbox-close {
  top: 20px;
  right: 30px;
}

.lightbox-prev {
  top: 50%;
  left: 30px;
  transform: translateY(-50%);
}

.lightbox-next {
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}
</style>
